import Link from 'next/link';
import React from 'react'
import LogoSvg from '../../svgs/LogoSvg';

const Footer = () => {
  return (
    <footer className="w-full  dark:bg-theme-dark-bg text-white text-center ">
      <div className="rounded-t-2xl bg-theme-dark-light w-full">
        <div className="py-6 max-w-3xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex flex-col flex-1 items-center whitespace-nowrap space-y-4 lg:space-y-0  lg:flex-row lg:justify-between">
              <div className="hidden lg:block">
                <LogoSvg className="h-6 w-auto" footer />
              </div>
              <Link href="/privacidad"><a>Política de privacidad</a></Link>
              <Link href="/terminos"><a>Términos y condiciones</a></Link>
              <div className="text-primary">2021 Codealo<sup>&#174;</sup></div>
              <div className="lg:hidden">
                <LogoSvg footer className="h-6"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer
